import Splide from '@splidejs/splide';

import Alpine from 'alpinejs'

window.Alpine = Alpine
Alpine.start();

const initSlideshowNested = (container) => {
  const splideEl = container.querySelector('.splide');
  if (!splideEl) return;

  const fade    = container.dataset.fade     === 'true';
  const autoplay= container.dataset.autoplay === 'true';
  const interval= parseInt(container.dataset.interval,10) || 5000;
  const arrows  = container.dataset.arrows   === 'true';
  const dots    = container.dataset.dots     === 'true';

  new Splide(splideEl, {
    type: fade ? 'fade' : 'loop',
    autoplay,
    interval,
    arrows,
    pagination: dots,
    speed: 600,
  }).mount();
};

// Shopify Sections API ile panele ekle
document.addEventListener('DOMContentLoaded', () => {
  Shopify.theme.sections.onLoad('slideshow-nested', (section) => {
    initSlideshowNested(section.container);
  });
  Shopify.theme.sections.onSelect('slideshow-nested', (section) => {
    initSlideshowNested(section.container);
  });
});